import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import { UserStatusType } from "~~/package/mapper/user/model/UserStatusType";

export class ContestLeaderBoardModel extends Model {
    constructor(
        public userUUID: string = "",
        public userId: number = 0,
        public userStatus: UserStatusType = UserStatusType.NORMAL,
        public profileImageUrl: string = "",
        public nickName: string = "",
        public lastSubmission: string = "",
        public averageScore: string = "",
        public rank: string = "",
        public entries: number = 0,
        public awardFlag: boolean = false,
        public totalQuestion: number = 0
    ) {
        super();
    }

    public static create(model: Partial<ContestLeaderBoardModel>): ContestLeaderBoardModel {
        return createModel<ContestLeaderBoardModel>(ContestLeaderBoardModel, {
            ...model
        });
    }
}
